<script>import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const AllGamesTabIcon = getIcon("AllGamesTabIcon");
export let size = 17;
export let active = false;
export let hover = false;
export let color = void 0;
</script>

{#if typeof AllGamesTabIcon === 'string'}
	<img src={AllGamesTabIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof AllGamesTabIcon === 'function'}
	<svelte:component this={AllGamesTabIcon} {size} {active} {hover} {color} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
